import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-down-right"><path d="M18.25 8.75V18.25H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6 6L17.6002 17.6002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowDownRight;
